import { useRemoveSectionImageMutation } from 'services/api/vehicle-sections';
import { useCameraViewContext } from '../../context';
import { useField } from 'react-final-form';
import toast from 'react-hot-toast';
import { useFieldArray } from 'react-final-form-arrays';
import { useRemoveImage } from 'pages/ListerVehicleUploadV2/hooks/useRemoveImage';

export function useCameraControls() {
  const {
    setIndex,
    level1SectionId,
    localRetakeImage,
    currentImageSrc,
    imageIndex,
    isVideoMode
  } = useCameraViewContext();
  const [removeImageMutation] = useRemoveSectionImageMutation();
  const removeImage = useRemoveImage();

  const {
    input: { value: image }
  } = useField(`${level1SectionId}.images.${imageIndex}`);

  const {
    input: { value: vehicleId }
  } = useField(`vehicleId`);
  const { fields } = useFieldArray(`${level1SectionId}.images`);

  const handleRemove = async () => {
    if (isVideoMode) {
      return localRetakeImage();
    }

    if (currentImageSrc) {
      return localRetakeImage();
    }

    if (!image) {
      console.info(`Image not found`);
      return localRetakeImage();
    }

    const lengthBeforeRemoval = fields.length || 0;

    const afterRemove = () => {
      if (image.type) {
        fields.update(imageIndex, {
          ...fields.value[imageIndex],
          url: '',
          url_thumb: '',
          local_url: '',
          delete_scheduled: true
        });
      } else {
        fields.remove(imageIndex);
        setIndex(lengthBeforeRemoval - 1);
      }

      localRetakeImage();
    };

    await removeImage(image.id, !!image.type, afterRemove);

    // const response = await removeImageMutation({
    //   vehicleId,
    //   sectionId: -1,
    //   imageId: image.id
    // });

    // if ('data' in response) {
    //   toast.success('Image removed');
    //   if (image.type) {
    //     fields.update(imageIndex, { ...fields.value[imageIndex], url: '', url_thumb: '' });
    //   } else {
    //     fields.remove(imageIndex);
    //     setIndex(lengthBeforeRemoval - 1);
    //   }

    //   localRetakeImage();
    // } else {
    //   toast.error('Failed to remove image');
    // }
  };

  const handleRetake = handleRemove;

  return { handleRemove, handleRetake };
}
